import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
import { trackAddToCartAndRedirect } from '../lib/metaPixel';
import { useOrder } from '../lib/orderContext';
export function Hero() {
  const {
    total,
    formattedTotal,
    checkoutUrl
  } = useOrder();
  const goToCheckout = () => {
    trackAddToCartAndRedirect(checkoutUrl, {
      content_name: 'El Protocolo Meno-Metabólico + 3 Bonos',
      content_ids: ['42499535011925'],
      content_type: 'product',
      value: total,
      currency: 'USD'
    });
  };
  return <section className="bg-[#faf6ee] py-10 md:py-16 overflow-hidden" data-id="element-108">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109">
        <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-110">
          {/* Image Side - Left on desktop, Top on mobile */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="order-1" data-id="element-111">
            <img src="https://cdn.magicpatterns.com/uploads/5ftZRvTSU6Y3aDvE3MiL4J/Protocolo_2B_3_BONOS_-_PORTADA.png" alt="El Protocolo Meno-Metabólico" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-112" />
          </motion.div>

          {/* Content Side */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="order-2 text-center md:text-left flex flex-col justify-center" data-id="element-113">
            <div className="inline-block bg-[#c9a961]/20 text-[#b8954d] px-4 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase mb-6 mx-auto md:mx-0 border border-[#c9a961]/30" data-id="element-114">
              LEGADO SALUD
            </div>

            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#2d2d2d] leading-tight mb-4" data-id="element-115">
              El Protocolo Meno-Metabólico
            </h1>

            <p className="text-lg md:text-xl text-[#5d6e4f] mb-6 leading-relaxed" data-id="element-116">
              El método de 21 días para recuperar tu peso, energía y sueño
              después de los 50
            </p>

            <div className="w-16 h-px bg-[#c9a961] mb-8 mx-auto md:mx-0" data-id="element-117"></div>

            <div className="mb-8 flex flex-col items-center md:items-start" data-id="element-118">
              <span className="text-xl md:text-2xl text-[#a8a8a8] line-through mb-1" data-id="element-119">
                $37 USD
              </span>
              <motion.span key={formattedTotal} initial={{
              opacity: 0,
              y: -10
            }} animate={{
              opacity: 1,
              y: 0
            }} className="font-serif text-5xl md:text-6xl font-bold text-[#2d4a3e]" data-id="element-120">
                {formattedTotal}
              </motion.span>
            </div>

            <motion.button onClick={goToCheckout} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full bg-[#2d4a3e] text-white px-8 py-5 rounded-lg text-lg md:text-xl font-bold shadow-xl hover:bg-[#1f3a2e] transition-colors" data-id="element-121">
              Descárgalo Ahora Por {formattedTotal}
            </motion.button>

            <div className="mt-4 flex items-center justify-center md:justify-start gap-2 text-sm text-[#7a8a6b]" data-id="element-122">
              <LockIcon className="w-4 h-4" data-id="element-123" />
              <span data-id="element-124">🔒 Pago seguro · Acceso inmediato</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}